export default {
  mount: '.icon-keyboard-arrow-down',
  attrs: {
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  path: '<polygon id="Path" fill="#424242" fill-rule="nonzero" points="7.41 8.59 12 13.17 16.59 8.59 18 10 12 16 6 10"></polygon>'
}
